<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="acceptButton" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title="$t('products.sync_product')")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("products.code_placeholder")' :danger="$v.form.code.$invalid && $v.form.code.$model" :danger-text="$t('validation.required', { attribute: $t('products.code') })" v-model="form.code" :label='$t("products.code")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Products')

export default {
  name: 'ModalProducts',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        code: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'canSync', 'syncro'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'syncRecord',
      'deleteRecord',
      'setModalVisible',
      'getQuantityJobs',
      'checkSyncro',
      'setCanSync'
    ]),
    acceptButton () {
      this.getQuantityJobs().then((quantity) => {
        if (!quantity) {
          this.checkSyncro().then(() => {
            if (this.syncro) {
              this.setModalVisible(false)
              this.$vm.dialog({
                color: 'primary',
                title: this.$t('strings.please_wait'),
                text: this.$t('strings.will_refresh_at_finish')
              })
              this.syncRecord({ ...this.form })
              this.startInterval(true)
            }
          })
        } else {
          this.$vm.dialog({
            color: 'danger',
            title: this.$t('strings.pending_jobs'),
            text: this.$t('strings.wait_til_finish_jobs')
          })
        }
      })
    },
    startInterval (withReload = false) {
      this.setCanSync(false)
      setTimeout(() => {
        this.interval(withReload)
      }, 2000)
    },
    interval (withReload) {
      this.getQuantityJobs().then((quantity) => {
        if (quantity) {
          setTimeout(() => {
            this.interval(withReload)
          }, 5000)
        } else {
          this.setCanSync(true)
          if (withReload) window.location.reload()
        }
      })
    }
  }
}
</script>
